__turbopack_context__.v({
  "bg": "BgParallax-module-scss-module__bCGqeG__bg",
  "bgLoaded": "BgParallax-module-scss-module__bCGqeG__bgLoaded",
  "bgLoading": "BgParallax-module-scss-module__bCGqeG__bgLoading",
  "bgSkeleton": "BgParallax-module-scss-module__bCGqeG__bgSkeleton",
  "bgSkeletonPulse": "BgParallax-module-scss-module__bCGqeG__bgSkeletonPulse",
  "inner": "BgParallax-module-scss-module__bCGqeG__inner",
});
